import React from "react";
import { StepProps } from "../../types";
import { useWebTranslation } from "translations";
import ChatMessage, { ChatContainer } from "ui-kit/ChatMessage/ChatMessage";
import { Typography } from "ui-kit/Typography";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { Radio } from "ui-kit/Radio";
import { useCurrentInsuranceByAnimalId } from "components/Signup/store/selectors/insurance";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import Gutter from "ui-kit/Gutter";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";
import { updateInsuranceById } from "components/Signup/store/slices/animals";
import { useIsLoading } from "components/Signup/store/selectors/metadata";

const LiabilityPreviousClaimsQuestion = ({
  next,
  previous,
  isValid,
  transitioning,
}: StepProps) => {
  const { t } = useWebTranslation();
  const dispatch = useSignupDispatch();
  const isLoading = useIsLoading();
  const { id } = useCurrentAnimal();
  const { liabilityNumberOfClaimsHistory, id: insuranceId } =
    useCurrentInsuranceByAnimalId(id);

  return (
    <ChatContainer leaving={transitioning}>
      <ChatMessage>
        <Typography>
          {t("previous_claims.germany.liability.question.title")}
        </Typography>
      </ChatMessage>
      <ChatMessage
        fromMe
        index={2}
        onPress={() => {
          dispatch(
            updateInsuranceById({
              id: insuranceId,
              update: { liabilityNumberOfClaimsHistory: "no_claims" },
            })
          );
        }}
      >
        <Radio active={liabilityNumberOfClaimsHistory === "no_claims"}>
          <Typography>Keine</Typography>
        </Radio>
      </ChatMessage>
      <ChatMessage
        fromMe
        index={2}
        onPress={() => {
          dispatch(
            updateInsuranceById({
              id: insuranceId,
              update: { liabilityNumberOfClaimsHistory: "one_claim" },
            })
          );
        }}
      >
        <Radio active={liabilityNumberOfClaimsHistory === "one_claim"}>
          <Typography>Einen</Typography>
        </Radio>
      </ChatMessage>
      <ChatMessage
        fromMe
        index={2}
        onPress={() => {
          dispatch(
            updateInsuranceById({
              id: insuranceId,
              update: { liabilityNumberOfClaimsHistory: "two_claims" },
            })
          );
        }}
      >
        <Radio active={liabilityNumberOfClaimsHistory === "two_claims"}>
          <Typography>Zwei</Typography>
        </Radio>
      </ChatMessage>
      <ChatMessage
        fromMe
        index={2}
        onPress={() => {
          dispatch(
            updateInsuranceById({
              id: insuranceId,
              update: {
                liabilityNumberOfClaimsHistory: "three_or_more_claims",
              },
            })
          );
        }}
      >
        <Radio
          active={liabilityNumberOfClaimsHistory === "three_or_more_claims"}
        >
          <Typography>Drei oder mehr</Typography>
        </Radio>
      </ChatMessage>
      <Gutter size={2} />
      {liabilityNumberOfClaimsHistory === "three_or_more_claims" && (
        <ErrorMessage>
          <Typography color={"error"}>
            {t(
              "previous_claims.germany.liability.question.three_or_more_answer"
            )}
          </Typography>
        </ErrorMessage>
      )}
      <FlowButtons
        inProgress={transitioning || isLoading}
        backButton={false}
        next={next}
        disabled={!isValid}
        previous={previous}
      />
    </ChatContainer>
  );
};

export default LiabilityPreviousClaimsQuestion;
